import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-label",
  templateUrl: "./field-set-label.component.html",
  styles: [],
})
export class FieldSetLabelComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
